import { Check, Settings, X } from "lucide-react";
import useModal from "../../../hooks/useModal";
import { Button } from "@oc-labs/wt-storybook";

export default function OnrampCard({ method, deleteMethod }) {
  const { open } = useModal("method-system");

  const handleConfigureMethod = () => {
    open({
      ...method,
      operators: method.operators.map(op => ({
        ...op,
        paymentMethods: {
          card: op.paymentMethods.includes(`card`),
          bankTransfer: op.paymentMethods.includes(`bankTransfer`),
        }
      })),
    })
  }

  return (<>
    <td className="px-4 py-3 whitespace-nowrap">
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-gray-100 text-gray-700 text-sm font-medium">
        Onramp
      </span>
    </td>
    <td className="px-4 py-3 text-sm text-gray-600">{method?.contract?.name} <span className="text-xs text-gray-400 pl-2">{method?.contract?.network?.name || "" }</span></td>
    <td className="px-4 py-3 text-center">
      {method.requiresKyc ? (
        <Check className="h-4 w-4 text-green-600 mx-auto" />
      ) : (
        <X className="h-4 w-4 text-gray-400 mx-auto" />
      )}
    </td>
    <td className="px-4 py-3 text-sm text-gray-600">
      {method.operators ? (
        <span>{method.operators.length} operators</span>
      ) : (
        <span>-</span>
      )}
    </td>
    <td className="px-4 py-3 text-sm text-gray-600">
      {method.dailyLimit && <span>${method.dailyLimit.toLocaleString()}/day</span>} <br />
      {method.monthlyLimit && <span>${method.monthlyLimit.toLocaleString()}/mo</span>}
    </td>
    <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">
      {new Date(method.createdAt).toLocaleDateString()}
    </td>
    <td className="px-4 py-3 gap-4">
      <div className="flex justify-end gap-4">
        <Button className="max-w-32" size="small" onClick={handleConfigureMethod}>
          <Settings className="h-3.5 w-3.5" />
          Configure
        </Button>
        <Button className="max-w-32" size="small" type="danger" onClick={() => deleteMethod(method.id)}>
          <Settings className="h-3.5 w-3.5" />
          Delete
        </Button>
      </div>
    </td>
  </>)
}